import { createAction, props } from '@ngrx/store';
import { ILoaderActionPayload } from '../models/loader.model';
import { DataRetentionTimeItem } from '../../../api/models/data-retention-time-item';
import { SettingControllerUpdateDataRetentionPolicyTime$Params } from '../../../api/functions';
export const settingsActions = {
  dataRetentionPolicyLoad: createAction('settings/data-retention-policy/load'),
  dataRetentionPolicyDone: createAction(
    'settings/data-retention-policy/done',
    props<{ state: ILoaderActionPayload; data?: DataRetentionTimeItem }>(),
  ),
  setDataRetentionPolicyLoad: createAction(
    'settings/set-data-retention-policy/load',
    props<SettingControllerUpdateDataRetentionPolicyTime$Params>(),
  ),
  setDataRetentionPolicyDone: createAction(
    'settings/set-data-retention-policy/done',
    props<{ state: ILoaderActionPayload; data?: DataRetentionTimeItem }>(),
  ),
  setDataRetentionPolicySetstate: createAction(
    'settings/set-data-retention-policy/set-state',
    props<{ state: ILoaderActionPayload }>(),
  ),
};
